// extracted by mini-css-extract-plugin
export default {"contentOpen":"SmallDropdownContent_contentOpen__bQW2N","fadeIn":"SmallDropdownContent_fadeIn__jdAuO","contentClosed":"SmallDropdownContent_contentClosed__9c-oP"};